module.exports = __webpack_public_path__ + "img/service-tech-solutions.391e9228.png";